import { Component, EventEmitter, Input, Output } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ICONS } from '../../../models/const/icons';
import { animate, style, transition, trigger } from '@angular/animations';

@Component({
  selector: 'app-confirm-cancel-action-modal',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './confirm-cancel-action-modal.component.html',
  styleUrl: './confirm-cancel-action-modal.component.scss',
  animations: [
    trigger('fadeScale', [
      transition(':enter', [
        style({ opacity: 0, transform: 'translateY(12px) scale(0.96)' }),
        animate(
          '220ms cubic-bezier(0.16, 1, 0.3, 1)',
          style({ opacity: 1, transform: 'translateY(0) scale(1)' })
        )
      ]),
      transition(':leave', [
        animate(
          '160ms ease-in',
          style({ opacity: 0, transform: 'translateY(4px) scale(0.98)' })
        )
      ])
    ])
  ]
})
export class ConfirmCancelActionModalComponent {
  /**
   * Modal title & description (plain text, no translation).
   */
  @Input() title: string = 'Confirmation';
  @Input() description: string = 'Êtes-vous sûr de vouloir effectuer cette action ?';

  /**
   * Button labels (plain text, no translation).
   */
  @Input() confirmButtonLabel = 'Continuer';
  @Input() cancelButtonLabel = 'Annuler';

  /**
   * Optional extra CSS class for the confirm button (e.g. danger styles).
   */
  @Input() customClass = '';

  /**
   * Emits when the user confirms / cancels the action.
   */
  @Output() confirmed = new EventEmitter<void>();
  @Output() cancelled = new EventEmitter<void>();

  /**
   * Generic close event (true = confirmed, false = cancelled).
   * Can be handy if the parent only cares about the final result.
   */
  @Output() closed = new EventEmitter<boolean>();

  confirmHandler(): void {
    this.confirmed.emit();
    this.closed.emit(true);
  }

  cancelHandler(): void {
    this.cancelled.emit();
    this.closed.emit(false);
  }

  onBackdropClick(event: Event): void {
    const mouseEvent = event as MouseEvent;
    // Only close when clicking directly on the backdrop, not inside the modal
    if (mouseEvent.target === mouseEvent.currentTarget) {
      this.cancelHandler();
    }
  }

  onBackdropKey(event: Event): void {
    const keyboardEvent = event as KeyboardEvent;
    // Handle Enter / Space on the backdrop for accessibility
    if (keyboardEvent.target === keyboardEvent.currentTarget) {
      keyboardEvent.preventDefault();
      this.cancelHandler();
    }
  }

  protected readonly ICONS = ICONS;
}
